// Module
var code = `<div class="HOA-misc-guidedSteps__container">
    <div class="HOA-misc-guidedSteps__header">
        <div class="HOA-misc-guidedSteps__header-text">Select Amenity</div>
    </div>
    <div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded HOA-misc-guidedSteps__flex-align-bottom u-pT5">
        <div class="Field HOA-misc-guidedSteps__flex-child HOA-make-payment-w100">
            <label class="Field-label" for="amenityCategorySelect">
                Category
            </label>
            <div class="Select">
                <select tid="amenityCategorySelect"
                        id="amenityCategorySelect"
                        [(ngModel)]="selectedCategory"
                        (change)="changeSelectedCategory()">
                    <option *ngFor="let category of availableCategories" [ngValue]="category">
                        {{category.description}}
                    </option>
                </select>
                <span class="Select-arrow"></span>
            </div>
        </div>
        <span class="HOA-make-guidedSteps_middleColumn"> </span>
        <div class="HOA-misc-guidedSteps__flex-child HOA-make-payment-w100"></div>
    </div>
    <div class="HOA-misc-guidedSteps__flex HOA-misc-guidedSteps__flex-padded HOA-misc-guidedSteps__flex-align-bottom u-pB3">
        <div class="Field HOA-misc-guidedSteps__flex-child HOA-make-payment-w100">
            <label class="Field-label" for="amenitySelect">
                Amenity
            </label>
            <div class="Select">
                <select tid="amenitySelect" id="amenitySelect" [(ngModel)]="selectedAmenity">
                    <option [ngValue]=""></option>
                    <option *ngFor="let amenity of filteredAmenities" [ngValue]="amenity">
                        {{amenity.description + ' \$' + amenity.totalAmount }}
                    </option>
                </select>
                <span class="Select-arrow"></span>
            </div>
        </div>
        <span class="HOA-make-guidedSteps_middleColumn"> </span>
        <div class="Field HOA-misc-guidedSteps__flex-child">
            <button id="addAmenityButton"
                    tid="addAmenityButton"
                    class="Button Button--blue HOA-make-payment-button"
                    ifOverFlowXClass="Button--overflowX"
                    (click)="addAmenityToCart()">
                Add
            </button>
        </div>
    </div>
</div>`;
// Exports
module.exports = code;